import React, { useEffect, useRef, useState } from 'react';
import { base_api_url } from '../../../services/httpService.js';
import { CircularProgress } from '@mui/material';

const ServiceImage = ({ rowData, scrollQuery="#div-content" }) => {
    const [imgURL, setImgURL] = useState(null);
    const [condition, setCondition] = useState(false);

    const imageRef = useRef(null);

    const token = JSON.parse(localStorage.getItem("cncToken"));

    const getImageURL = () => {
        fetch(`${base_api_url}/shop_admin/get_service_image/${rowData.code}/`, {
            headers: {
                "Authorization": `Bearer ${token.access}`
            }
        })
            .then(response => response.blob())
            .then(blob => {
                if (blob.type === "text/html") {
                    setImgURL("");
                } else {
                    const url = URL.createObjectURL(blob);
                    setImgURL(url);
                }
            })
            .catch(error => {
                setImgURL("");
            });
    }

    const setConditionHandler = () => {
        const { top, bottom } = imageRef.current.getBoundingClientRect();
        if (bottom >= 0 && top <= window.innerHeight) {
            setCondition(true);
        }
    }

    useEffect(() => {
        if (imageRef && imageRef.current && scrollQuery) {
            setConditionHandler();
            if (document.querySelector(scrollQuery)) {
                document.querySelector(scrollQuery).addEventListener("scroll", setConditionHandler);
            }
        }

        return () => {
            if (document.querySelector(scrollQuery)) {
                document.querySelector(scrollQuery).removeEventListener("scroll", setConditionHandler);
            }
        }
    }, [imageRef]);

    useEffect(() => {
        if (rowData.image && condition && imgURL === null) {
            getImageURL();
        }
    }, [condition, imgURL]);

    return (
        <div
            ref={imageRef}
        >
            {rowData.image ?
                imgURL === null ? (
                    <CircularProgress
                        color="primary"
                        size={40}
                    />
                ) : (
                    <img
                        src={imgURL || "/assets/Pics/wisercam.jpeg"}
                        alt="Service Pic"
                        className="max-w-xs max-h-28 
                        rounded-lg mx-auto object-cover"
                    />
                ) : (
                    <span className="text-red-500">فاقد تصویر</span>
                )}
        </div>
    );
}

export default ServiceImage;
